import ToggleByController from "./toggle_by_controller"

/**
 * Hides/shows an element based on the state of a checkbox, radio, or select input.
 * Inputs inside hidden elements are disabled to prevent form submission of hidden values.
 *
 * @example Radio button
 *   <input type="radio" name="option" value="a"> A
 *   <input type="radio" name="option" value="b"> B
 *
 *   <div data-controller="hide-by" data-hide-by-radio="[name=option]" data-hide-by-value="a">
 *     Hidden when A is selected
 *   </div>
 *
 * @example Checkbox
 *   <input type="checkbox" id="toggle">
 *   <div data-controller="hide-by" data-hide-by-checkbox="#toggle">
 *     Hidden when checked
 *   </div>
 *
 * @example Select
 *   <select id="my-select">
 *     <option value="x">X</option>
 *     <option value="y">Y</option>
 *   </select>
 *   <div data-controller="hide-by" data-hide-by-select="#my-select" data-hide-by-value="x">
 *     Hidden when X is selected
 *   </div>
 *
 * @example Multiple values
 *   <div data-controller="hide-by" data-hide-by-radio="[name=my-radio]" data-hide-by-values="a,b">
 *     Hidden when A or B is selected
 *   </div>
 */
export default class extends ToggleByController {
  toggle = (isToggled) => {
    if (isToggled) {
      this.element.classList.add("hidden")
      this._disableInputs()
    } else {
      this.element.classList.remove("hidden")
      this._enableInputs()
    }
  }

  _enableInputs() {
    this.element
      .querySelectorAll(
        "input:not([type=hidden]):not(trix-toolbar input), textarea, select",
      )
      .forEach((input) => {
        input.disabled = false
        input.tomselect?.enable()
      })
  }

  _disableInputs() {
    this.element
      .querySelectorAll(
        "input:not([type=hidden]):not(trix-toolbar input), textarea, select",
      )
      .forEach((input) => {
        input.disabled = true
        input.tomselect?.disable()
      })
  }
}
